// import "./App.css"
// import { useEffect, useState } from "react";

// function MyForm() {
//   const [name, setName] = useState("");
//   const [long, setLong] = useState(0);
//   const [lat, setLat] = useState(0);

//   function handleChange(e) {
//     setName(e.target.value);
//   }

//   function handleLongChange(e) {
//     setLong(parseFloat(e.target.value));
//   }

//   function handleLatChange(e) {
//     setLat(parseFloat(e.target.value));
//   }

//   function handleSubmit(e) {
//     e.preventDefault();
//     alert(name);
//     alert((long + lat).toString());

//     // P
//   }

//   return (
//     <form onSubmit={handleSubmit}>
//       <label>Enter POI name
//         <input
//           type="text" 
//           value={name}
//           onChange={handleChange}
//         />
//       </label>
      
//       <br></br>
//       <label>Enter Longitude of poi 
//         <input
//           type="number"
//           value={long}
//           onChange={handleLongChange}>
//         </input>
//       </label>

//       <br></br>
//         <label>Enter Latitude of poi 
//         <input
//           type="number"
//           value={lat}
//           onChange={handleLatChange}>
//         </input>
//       </label>

//       <br></br>
//       <input type="submit" />
//     </form>
//   )
// }

// function App() {
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     fetch("/api/hello")
//       .then(res => res.json())
//       .then(data => setMessage(data.message))
//       .catch(err => console.log(err));
//   }, []);

//   return (
//     <div>
//       <h1>React + Flask</h1>
//       <p>{message}</p>
//       <MyForm></MyForm>
//     </div>
//   );
// }

// export default App;

import { useState } from "react";

function App() {
  const [form, setForm] = useState({
    name: "",
    description: "",
    latitude: "",
    longitude: "",
    type: "",
    tags: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      latitude: parseFloat(form.latitude),
      longitude: parseFloat(form.longitude),
      tags: form.tags.split(",").map(tag => tag.trim())
    };

    try {
    await fetch("/api/add_place", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    alert("Place added!");
  } catch (err)
  {
    alert("Error")
  }
  };

  return (
    <div style={{padding:40}}>
      <h1>Add Place</h1>

      <form onSubmit={submitForm}>
        <div>
          <input
            name="name"
            placeholder="Name"
            onChange={handleChange}
          />
        </div>

        <div>
          <textarea
            name="description"
            placeholder="Description"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="latitude"
            placeholder="Latitude"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="longitude"
            placeholder="Longitude"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="type"
            placeholder="Type"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="tags"
            placeholder="Tags (comma separated)"
            onChange={handleChange}
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default App;
